import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-down-triangle",
  "use": "icon-icon-down-triangle-usage",
  "viewBox": "0 0 14.423 10.902",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14.423 10.902\" id=\"icon-icon-down-triangle\">\n  <path id=\"icon-icon-down-triangle_Path_88\" data-name=\"Path 88\" d=\"M0,0V14.423L10.9,7.211,8.459,5.595Z\" transform=\"translate(14.423) rotate(90)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol